const TIME = {
  TWO_HOURS: 60 * 60 * 2,
  ONE_YEAR: 60 * 60 * 24 * 365,
  ONE_DAY: 60 * 60 * 24,
};

module.exports = Object.freeze({
  TENANT: {
    CHILE: 'falabella-cl',
    PERU: 'falabella-pe',
    COLOMBIA: 'falabella-co',
  },
  COOKIES: {
    SESSION: { VALUE: 'sid', EXPIRY: TIME.ONE_DAY },
    AGENT_SESSION: { VALUE: 'agsid', EXPIRY: TIME.TWO_HOURS },
    CART_ID: { VALUE: 'cartId', EXPIRY: TIME.ONE_YEAR },
    ZONE_DATA: 'zoneData',
    CARTLINE_QUANTITIES: 'CARTLINE_QUANTITIES',
    LOCATION_DATA: 'locationData',
    CUSTOMER_DATA: 'customerData',
    DYNAMIC_DATA: { VALUE: 'DYNAMIC_DATA_COOKIE', EXPIRY: TIME.ONE_YEAR },
    CMR_POINTS: 'CMR_POINTS',
    USER_ID: { VALUE: 'USER_ID', EXPIRY: TIME.ONE_YEAR },
    CATALYST_DATA: { VALUE: 'CATALYST_DATA_COOKIE', EXPIRY: TIME.ONE_YEAR },
    AGENT_DATA: { VALUE: 'AGENT_INFO', EXPIRY: TIME.TWO_HOURS },
    KIOSKO_DATA: { VALUE: 'KIOSKO_INFO', EXPIRY: TIME.TWO_HOURS },
    KIOSKO_STORE_ID: { VALUE: 'KIOSKO_STORE_ID', EXPIRY: TIME.ONE_YEAR },
    KIOSKO_MODULO: { VALUE: 'KIOSKO_MODULO', EXPIRY: TIME.ONE_YEAR },
    SELLER_EXPERIENCE: 'seller_experience',
    POLITICAL_ID: 'politicalId',
    PAYMENT_EXPERIENCE: 'payment_experience',
    F_AUTH_DEVICE_FIRST_SEEN_DATE: 'f-auth-device-first-seen-date',
    F_AUTH_DEVICE_ID: 'f-auth-device-id',
    F_AUTH_DEVICE_RECOGNIZED: 'f-auth-device-recognized',
    USER_FPAY_LINK_STATUS: {
      VALUE: 'user_fpay_link_status',
      EXPIRY: 60 * 60 * 24 * 365,
      ACCOUNT_NOT_FOUND_EXPIRY: 60 * 60 * 3,
    },
    SESSION_CONFIRMATION_NUMBER: { VALUE: 'scn', EXPIRY: TIME.TWO_HOURS },
    ADDRESS_LINES: 'addressLines',
    ADDRESS_ID: 'addressId',
    DELIVERY_FLOW: 'deliveryFlow',
    USER_SEGMENT: { VALUE: 'userSegments', EXPIRY: TIME.ONE_DAY },
  },
  SESSION_STORAGE: {
    CATALYST_EMAIL_ID: 'CATALYST_EMAIL_ID',
    EMAIL: 'email',
    CATALYST_USER_TYPE: 'CATALYST_USER_TYPE',
    DIGITAL_DATA: 'DIGITAL_DATA',
    USER_DATA: 'userData',
    IS_DEVICE_RECOGNISED: 'isDeviceRecognised',
    F_AUTH_DEVICE_ID: 'fAuthDeviceId',
  },
  LOCAL_STORAGE: {
    USER_FPAY_LINK_TOKEN: 'USER_FPAY_LINK_TOKEN',
    USER_REQUIRED_FILEDS: 'USER_REQUIRED_FILEDS',
    CATALYST_EMAIL_ID: 'CATALYST_EMAIL_ID',
    CATALYST_USER_TYPE: 'CATALYST_USER_TYPE',
    DEVICE_IDENTIFIER: '__fadid',
    ADDRESS_LINES: 'addressLines',
    COMUNA_DATA: 'comunaData',
    REGION_DATA: 'regionData',
  },
  DEFAULT_PRICE_GROUP: 'default',
  LOGIN_STATUS: {
    SOFT: 'Soft',
    AUTHENTICATED: 'Authenticated',
    GUEST: 'Guest',
  },
  SELLER_EXPERIENCE: {
    MARKETPLACE: 'MARKETPLACE',
    RETAIL: 'RETAIL',
  },
  OTP: {
    OPERATION_TYPE: {
      TEMPORARY_PASS: 'otp_temporary_code',
      OTP_FORGET_PASS: 'otp_forget_pass',
      OTP_NEW_REGISTERED_DEVICE: 'otp_new_registered_device',
    },
  },
  PAYMENT_EXPERIENCE: {
    SEAMLESS: 'SEAMLESS',
    CATALYST: 'CATALYST',
  },
  IDENTITY_VALIDATOR: {
    CIAM: 'CIAM',
  },
  COMMERCE_HEADER: 'FCM',
  CONSENT_STATUS: {
    ACCEPTED: '1',
    NOT_ACCEPTED: '2',
  },
  ECOMM_NAME_TOTTUS: 'marketplacetottus',
});
